<img [src]="condition == 'new' ? '/static/images/cleargraph.png' : '/static/images/clear-care-used.png'" class="d-block w-100"/>
